const ITEMS = [
  "Pizza fragrante",
  "Burger & piatti del pub",
  "Signature cocktails",
  "Birre fresche",
  "Eventi & serate",
  "Ceccano — Via Giacomo Matteotti 398",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-slate2 border-y border-gold/20 py-3.5 overflow-hidden" data-testid="marquee-ribbon" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center text-[11px] sm:text-xs font-semibold uppercase tracking-[0.28em] text-cream-muted whitespace-nowrap">
                <span className="px-6">{item}</span>
                <svg viewBox="0 0 48 48" className="w-2.5 h-2.5 text-burgundy-glow shrink-0"><path d="M24 3 43 18 24 45 5 18Z" fill="currentColor" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
